import { render, staticRenderFns } from "./encuesta.vue?vue&type=template&id=1fcd0012"
import script from "./encuesta.vue?vue&type=script&lang=js"
export * from "./encuesta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports